import { useContext } from 'react';

import ScreenModalContext from './ModalContextV2';

export const useScreenModalV2 = (BaseComponent) => {
  const { showModalComponent } = useContext(ScreenModalContext);

  return async (props) => {
    return new Promise((resolve) => {
      showModalComponent(BaseComponent, {
        ...props,
        onSubmit: resolve,
      });
    });
  };
};
